import { render, staticRenderFns } from "./CovidRow.vue?vue&type=template&id=378f4811&scoped=true&"
import script from "./CovidRow.vue?vue&type=script&lang=js&"
export * from "./CovidRow.vue?vue&type=script&lang=js&"
import style0 from "./CovidRow.vue?vue&type=style&index=0&id=378f4811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378f4811",
  null
  
)

export default component.exports